<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn text small v-on="on"><v-icon v-show="hover" small>add</v-icon> Create New Workspace</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Add a new Context workspace</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  autofocus
                  v-model="workspace.name"
                  label="Workspace Name"
                  required
                  @keypress.enter="create"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-alert :value="!!error" type="warning">{{ error }}</v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click="create">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: ['hover'],
  data() {
    return {
      dialog: false,
      error: false,
      workspace: {
        name: ''
      }
    };
  },
  methods: {
    create() {
      if (!this.workspace.name.length) {
        this.error = 'Your workspace needs a name!';
        return;
      }
      this.$emit('create', { name: this.workspace.name });
      //  close and reset
      this.dialog = false;
      this.workspace.name = '';
      this.error = false;
    }
  }
};
</script>
